import React from 'react';
import {useStyles} from "./Link.style";
import {useCommonStyles} from "../common/CommonStyles.style";
import LinkProperties from "./LinkProperties";
import clsx from "clsx";


const Link: React.FC<LinkProperties> = ({
                                            text,
                                            to,
                                            onClick,
                                            startIcon: StartIcon,
                                            endIcon: EndIcon,
                                            fullWidth = false,
                                            className = '',
                                            disabled = false,
                                        }: LinkProperties) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    const containerClasses = clsx(
        className,
        classes.link_container,
        fullWidth && commonClasses.fullWidth,
        disabled && classes.disabled);

    return (
        <div className={containerClasses}>
            {StartIcon &&
            <div className={classes.start_icon_container}>
                <StartIcon fontSize='small'/>
            </div>}
            <a className={classes.anchor} href={to} onClick={onClick}>{text}</a>
            {EndIcon &&
            <div className={classes.end_icon_container}>
                <EndIcon fontSize='small'/>
            </div>}
        </div>
    )
}
export default Link;